import { createSelector } from 'reselect';

const selectSections = (state: any) => state.sections;


export const selectSectionsCurrentItem = createSelector([selectSections], (sections) => sections.current);

export const selectSectionsListItems = createSelector([selectSections], (sections) => sections.list);

export const selectSectionsItemById = (itemId: any) =>
    createSelector(selectSectionsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectSectionsQueryItems = createSelector([selectSections], (sections) => sections.query);

export const selectSectionsCreatedItem = createSelector([selectSections], (sections) => sections.create);

export const selectSectionsUpdatedItem = createSelector([selectSections], (sections) => sections.update);

export const selectSectionsReadItem = createSelector([selectSections], (sections) => sections.read);

export const selectSectionsDeletedItem = createSelector([selectSections], (sections) => sections.delete);

export const selectSectionsearchedItems = createSelector([selectSections], (sections) => sections.search);

export const selectSectionsItemsCount = createSelector([selectSections], (sections) => sections.count);

export const selectSectionsItemsFilter = createSelector([selectSections], (sections) => sections.filter);